export default __webpack_public_path__ + "static/media/api-credential-red.59caf594.svg";